import { useContext, RefObject } from 'react';
import { Card } from '@mui/material';

import { DetailedRoute } from '@/generated/model/detailedRoute';
import { ctxRoutes } from '@/contexts/RoutesCtx.tsx';
import { RouteInfoCard } from './RouteInfoCard';

import './RouteStyle.css';

function getHighlightedDuration(routes: DetailedRoute[], highlightedRouteIds?: number[]): number {
  if (highlightedRouteIds && highlightedRouteIds.length > 0) {
    return routes
      .filter((route) => highlightedRouteIds.includes(route.id))
      .reduce((acc, route) => acc + route.durationTimeMicros, 0);
  }

  return routes.reduce((acc, route) => acc + route.durationTimeMicros, 0);
}

function getHighlightedStandTime(routes: DetailedRoute[], highlightedRouteIds?: number[]): number {
  if (highlightedRouteIds && highlightedRouteIds.length > 0) {
    return routes
      .filter((route) => highlightedRouteIds.includes(route.id))
      .reduce((acc, route) => acc + route.standTimeMicros, 0);
  }

  return routes.reduce((acc, route) => acc + route.standTimeMicros, 0);
}

export function RoutesSummary({ ref }: { ref: RefObject<HTMLDivElement | null> }) {
  const ctx = useContext(ctxRoutes);

  if (!ctx || !ctx.routes || !ctx.routes.length || !ctx.selectedTarget || !ctx.selectedDates) return null;

  const sumDurationTimeMicros: number = getHighlightedDuration(ctx.routes, ctx.highlightedRoutes);
  const sumStandTimeMicros: number = getHighlightedStandTime(ctx.routes, ctx.highlightedRoutes);

  const startRoute =
    ctx.routes.find((route) => {
      if (ctx.highlightedRoutes) return route.id === ctx.highlightedRoutes[0];
    }) ?? ctx.routes[0];

  const stopRoute =
    ctx.routes.find((route) => {
      if (ctx.highlightedRoutes) return route.id === ctx.highlightedRoutes[ctx.highlightedRoutes.length - 1];
    }) ?? ctx.routes[ctx.routes.length - 1];

  const startPosition = startRoute?.startPosition;
  const stopPosition = stopRoute?.stopPosition;

  const hightLightSum = ctx.routes.filter((route) => ctx.highlightedRoutes?.includes(route.id));
  const sum = hightLightSum.length > 0 ? hightLightSum : ctx.routes;

  const imaginaryRoute: DetailedRoute = {
    id: 0,
    startPosition,
    stopPosition,
    durationTimeMicros: sumDurationTimeMicros,
    distanceKm: sum.reduce((acc, current) => acc + current.distanceKm, 0),
    standTimeMicros: sumStandTimeMicros,
    privateRoute: false,
    events: [],
  };

  return (
    <Card
      ref={ref}
      className={`route-summary-card ${ctx.highlightedRoutes?.length ? 'route-summary-card-content-with-highlight' : ''}`}
      data-qa-element-id="route_summary_panel"
    >
      <RouteInfoCard
        route={imaginaryRoute}
        privateRoutes={{ from: startRoute.privateRoute, to: stopRoute.privateRoute }}
      />
    </Card>
  );
}
